module.exports = __webpack_public_path__ + "img/moderate.ded5effd.svg";